const jsonResponseMessage = function (response) {
  return response.responseJSON ? response.responseJSON : response.statusText;
};

export default jsonResponseMessage;
